import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';
import featureFlags from 'util/featureFlags';

const OLD_FAVORITES = '/inspiration/favorites';
const PAPER_FAVORITES = '/favorites/paper';
const VENDOR_FAVORITES = '/favorites/vendors';

export const getFavoritesLink = (primaryLinkId) => {
  if (!featureFlags.get('cardsFavoriting')) return OLD_FAVORITES;

  return primaryLinkId === NAV_DATA.PRIMARY.PAPER ? PAPER_FAVORITES : VENDOR_FAVORITES;
};
